export default __webpack_public_path__ + "static/media/36.6128911b.jpeg";